import dayjs from 'dayjs';

import { getLastWeekdayOfMonth } from './getLastWeekdayOfMonth.ts';

export function getMonthlyLastWeekdayRecurrenceDates({ startDate, amount }: { startDate: Date; amount: number }) {
  const start = dayjs(startDate);
  const weekday = start.day();

  const results = [];

  for (let i = 0; i < amount; i++) {
    const currentYear = start.add(i, 'month').year();
    const currentMonth = start.add(i, 'month').month(); // 0-based
    const lastOccurrence = getLastWeekdayOfMonth(currentYear, currentMonth, weekday);
    results.push(lastOccurrence);
  }

  return results;
}
